import { SupplierCreate } from './SupplierCreate'
import { SupplierEdit } from './SupplierEdit'
import { SupplierList } from './SupplierList'
import { SupplierShow } from './SupplierShow'

export { SupplierCreate, SupplierEdit, SupplierList, SupplierShow }
